import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function getMailingOrders() {
    const filter = {
        include: [
            'agent',
            'mailingProfile',
            'agency',
            'project',
            {'agencies': 'creator'}
        ]
    };
    return axios.get(`${SERVER_URL}/api/MailingOrders`, {
        params: { filter }
    })
    .then(({ data }) => data);
}

export function createMailingOrder(orderData) {
    return axios.post(`${SERVER_URL}/api/MailingOrders/create-order`, orderData)
    .then(({ data }) => data);
}

export function deleteMailingOrder(orderId) {
    return axios.delete(`${SERVER_URL}/api/MailingOrders/${orderId}`)
    .then(({ data }) => data);
}

export function generateMailingOrder(orderId) {
    return axios.get(`${SERVER_URL}/api/MailingOrders/${orderId}/generateOrder`)
    .then(({ data }) => data);
}

export default { createMailingOrder, getMailingOrders, deleteMailingOrder, generateMailingOrder };



// WEBPACK FOOTER //
// ./src/modules/services/mailing-order.service.js